<template >


  <div data-vjs-player>
    <video ref="videoPlayer" class="video-js vjs-default-skin vjs-big-play-centered"></video>
  </div>


  <!-- timeline custom-->
  <template
      v-if="
        inputObj.params.ad
        && inputObj.params.ad.status === true
      "
  >
    <div

        class="container bg-light rounded border mt-2 mb-5"
    >
      <div class="position-relative py-4 my-2 mx-3">
        <div class="progress" style="height: 5px;">
          <div
              ref="timeline"
              class="progress-bar bg-secondary"
              role="progressbar"
              style="width: 100%;"
              aria-valuenow="100"
              aria-valuemin="0"
              aria-valuemax="100"
          ></div>
        </div>
        <!-- aktualni cas-->
        <div
            class="position-absolute top-50 translate-middle-x"
            :style="'left: ' + videoData.progressProcent.toFixed(`2`) + '%; z-index: 1;'"
        >
          <div class="d-flex flex-column align-items-center">
            <!-- Rysková tečka na ose -->
            <div class="bg-primary rounded-circle" style="width: 20px; height: 20px; margin-top: -10px; border: 2px solid #fff;"></div>
            <!-- Tlačítko aktuálního času umístěné pod osou -->
            <button
                @click.prevent="addAd(videoData.currentTime)"
                type="button"
                class="btn btn-primary btn-sm mt-2 shadow-sm whitespace-nowrap"
            >
              <i class="bi bi-plus-circle"></i>
              <!-- <i class="bi bi-clock-fill me-1"></i>

              <span>{{formatTime(videoData.currentTime)}}
                 -->
            </button>
          </div>
        </div>

        <!-- markery-->
        <template
            v-for="(ad, index) in inputModel.ad"
        >
          <div
              @mousedown="startDrag($event, index)"
              class="position-absolute top-50 translate-middle-x"
              :style="'left: ' + (ad.time/videoData.duration*100).toFixed(2) + '%; z-index: ' + (index + 100) + '; user-select:none;'"
          >
            <div class="d-flex flex-column align-items-center">
              <!-- Bod na ose -->
              <div
                  class="bg-danger rounded-circle"
                  style="width: 10px; height: 10px; margin-top: -5px; border: 2px solid #fff;"
              ></div>
              <!-- Tlačítko pro smazání nad osou (přesunuté pomocí záporného marginu navrch) -->
              <div class="position-absolute bottom-100 mb-2">
                <button
                    @click.prevent="removeAd(index)"
                    type="button"
                    class="btn btn-outline-danger text-bg-lightS btn-sm p-1 d-flex align-items-center justify-content-center rounded-circle"
                    style="width: 24px; height: 24px;"
                    title="Odstranit značku"
                >
                  &times;
                </button>
              </div>
              <!-- Popisek pod osou -->
              <span class="badge bg-dark mt-2">{{formatTime(ad.time)}}</span>
            </div>
          </div>
        </template>

      </div>
    </div>


    <template
        v-if="inputObj.params.ad.auto_generate === true"
    >
      <button
          @click.prevent="distributeAds()"
        class="btn btn-outline-primary btn-sm me-2"
      >
        <i class="bi bi-diagram-3 me-1"/>
        Optimalni distrbuce
      </button>

    </template>


    <template
      v-if="inputObj.params.ad.auto_generate === true"
    >
      <button
          @click.prevent="generateAds()"
          class="btn btn-outline-primary btn-sm "
      >
        <i class="bi bi-database-add me-1"/>
        Automaticky generovat reklamy
      </button>
    </template>

  </template>




  <display-debug>
    <template #debugView>
      inputModel.ad: {{inputModel.ad}}
    </template>
  </display-debug>

<!--
  <display-debug>
    <template #debugView>
      inputObj.val: {{inputObj.val}}
    </template>
  </display-debug>

  <display-debug>
    <template #debugView>
      inputObj.params: {{inputObj.params}}
    </template>
  </display-debug>




  <display-debug>
    <template #debugView>
      videoData: {{videoData}}
    </template>
  </display-debug>
  -->
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
// Import pluginu pro zobrazení menu s výběrem kvalit

import 'videojs-quality-selector-hls';
import videojsChromecast from '@silvermine/videojs-chromecast';
import videojsAirPlay from '@silvermine/videojs-airplay';
import '@silvermine/videojs-chromecast/dist/silvermine-videojs-chromecast.css';
import '@silvermine/videojs-airplay/dist/silvermine-videojs-airplay.css';
export default {
  name: "PlayerHlsVideo",
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [Object, String, Number],
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  components: {
    //VideoPlayer,
  },
  data() {
    return {
      player: null,
      sources: [],
      videoData: {
        duration: 0,
        currentTime: 0,
        progressProcent: 0,
      },
      ad: {
        /*
        0: {
          name: "A",
          time: 0
        },
        1: {
          name: "B",
          time: 200
        },
        */
        2: {
          name: "V",
          time: 330
        }
      },
      markers: [{ id: 1, time: 30 }], // příklad bodu v čase 30s
      draggingMarker: null, //TODOmremove
      timelineRect: null,
      isDragging: false,
      activeAdIndex: null
    }
  },
  mounted() {
    const src = this.inputObj.val.src;
    this.inputModel = this.inputObj.val;
    if(
        Object.keys(this.inputModel.ad).length == 0
    ){
      this.inputModel.ad = {};
    }

    if (typeof videojs.getPlugin('chromecast') === 'undefined') {
      videojsChromecast(videojs);
    }
    if (typeof videojs.getPlugin('airPlay') === 'undefined') {
      videojsAirPlay(videojs);
    }

    const options = {
      autoplay: false,
      controls: true,
      responsive: true,
      fluid: true,
      sources: [{
        src: src,
        type: 'application/x-mpegURL' // VHS automaticky naparsuje Master Playlist
      }],
      techOrder: ['html5'],
      plugins: {
        chromecast: {
          receiverAppId: 'CC1AD845',
          addButtonToControlBar: true,
          metaData: {
            title: 'TODO CHROMECAST TITLE',
            subtitle: 'Streamování videa'
          }
        },
        airPlay: {
          addButtonToControlBar: true
        }
      }
    };

    this.player = videojs(this.$refs.videoPlayer, options, () => {
      // Inicializace pluginu pro výběr kvality po načtení přehrávače
      this.player.qualitySelectorHls();
      //console.log('Master playlist načten a plugin aktivován.');
    });

    this.player.on('loadedmetadata', () => {
      const videoLength = this.player.duration();
      this.videoData.duration = videoLength;
    });

    this.player.on('timeupdate', this.handleTimeUpdate);

    this.$nextTick(() => {
      if (this.$refs.timeline) {
        this.timelineRect = this.$refs.timeline.getBoundingClientRect();
        //console.log('dev timelineRect', this.timelineRect.width, this.timelineRect.left);
        //TODO resize
      }
    })

  },
  beforeUnmount() {
    if (this.player) {
      this.player.dispose();
    }
    window.removeEventListener('mousemove', this.onDrag);
    window.removeEventListener('mouseup', this.stopDrag);
  },
  computed: {},

  methods: {

    handleTimeUpdate() {
      // Pokud už reklama běží, nebudeme nic kontrolovat
      if (this.isAdPlaying) return;

      this.videoData.currentTime = Math.floor(this.player.currentTime());

      this.videoData.progressProcent = (this.player.currentTime() / this.videoData.duration) * 100;
    },


    removeAd(index) {
      console.log("removeAd", index);
      delete this.inputModel.ad[index];

    },

    addAd(time) {
      const count = Object.keys(this.inputModel.ad).length + 1
      this.inputModel.ad[count] = {
        'name': '_' + count,
        time: time,
      }


      console.log("addAd", count,time);
    },


    formatTime(time) {
      const hours = Math.floor(time / 3600);
      const minutes = Math.floor((time % 3600) / 60);
      const seconds = time % 60;

      const mm = String(minutes).padStart(2, '0');
      const ss = String(seconds).padStart(2, '0');

      if (hours > 0) {
        return `${hours}.${mm}.${ss}`;
      } else {
        return `${minutes}.${ss}`;
      }
    },

    distributeAds() {
      if(
          confirm("Opravdu chcete optimalizovat distribuci reklam?")
      ){
        console.log("distributeAds");
      }
    },

    generateAds() {
      alert("generateAds");
    },

    startDrag(event, index) {
      // Ignorujeme kliknutí pravým tlačítkem nebo kliknutí na mazací tlačítko
      if (event.button !== 0 || event.target.tagName === 'BUTTON') return;

      this.isDragging = true;
      this.activeAdIndex = index;

      // Přidáme globální listenery pro pohyb a puštění myši
      window.addEventListener('mousemove', this.onDrag);
      window.addEventListener('mouseup', this.stopDrag);

      // Změníme kurzor na "chyceno"
      document.body.style.cursor = 'grabbing';
    },

// Spouští se při každém pohybu myši během tažení
    onDrag(event) {
      if (!this.isDragging || this.activeAdIndex === null) return;

      //const timeline = this.refs.timeline; // Pokud Vue 3 setup, tak přes this.$refs.timeline
      //const timelineRect = this.$refs.timeline.getBoundingClientRect();

      const timelineRect = this.timelineRect;

          // Vypočítáme pozici myši relativně k začátku časové osy (v pixelech)
      let relativeX = event.clientX - timelineRect.left;

      // Ošetříme hranice (aby značka nevyjela mimo osu 0% až 100%)
      if (relativeX < 0) relativeX = 0;
      if (relativeX > timelineRect.width) relativeX = timelineRect.width;

      // Přepočítáme pixely na procenta a následně na sekundy videa
      const percentage = relativeX / timelineRect.width;
      const newTime = percentage * this.videoData.duration;

      // Aktualizujeme čas konkrétní reklamy (Vue automaticky překreslí left: XX%)
      this.inputModel.ad[this.activeAdIndex].time = Number(newTime.toFixed(2));
    },

    // Spustí se při puštění myši
    stopDrag() {
      if (!this.isDragging) return;

      this.isDragging = false;
      this.activeAdIndex = null;

      // Uklidíme globální listenery
      window.removeEventListener('mousemove', this.onDrag);
      window.removeEventListener('mouseup', this.stopDrag);

      // Vrátíme kurzor do normálu
      document.body.style.cursor = '';
    },







  },
  watch: {
    inputObj: {
      handler() {
        this.inputModel = this.inputObj.val;
      },
      deep: true,
      immediate: true
    },


    inputModel: {
      handler(newVal) {
        //newVal.ad = this.ad;
        this.$emit('update:modelValue', newVal )
      },
      deep: true,
      immediate: true
    },

  },

};
</script>
<style scoped>
.video-container { position: relative; }
.timeline-markers {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 20px;
  cursor: pointer;
  z-index: 100;
}
.marker {
  position: absolute;
  width: 10px; height: 10px;
  background: red;
  border-radius: 50%;
  transform: translateX(-50%);
}
</style>